import React from "react";
import Header from "../components/modules/layout/Header";
import { useSetRecoilState } from "recoil";
import { applyStepState } from "../recoil/pageStep";
import useApiActions from "../recoil/api";
import FooterButtonGroup from "../components/modules/layout/FooterButtonGroup";

const Practice = () => {
  const setApplyStep = useSetRecoilState(applyStepState);
  const { setLog } = useApiActions();

  return (
    <div>
      <Header />
      <div className="base-sec">
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              <p>영어 말하기 평가</p>
            </div>
            <div>
              <button className="close"></button>
            </div>
          </div>
          <div className="base-sec-sec practice-sec text-align-center">
            <div className="page-title text-align-center">
              <p>실전평가</p>
            </div>
            <div className="practice-img"></div>
            <div>
              <p className="practice-title">응시를 시작하겠습니다</p>
            </div>
            <div>
              <p className="practice-cont">
                시작 후에는 중단없이 한 번에 완료해야 하고,
                <br />
                다른 프로그램이나 새로고침, 뒤로가기 버튼을 사용하면 안됩니다.
                <br />
                준비가 완료되면 시작하세요.
              </p>
            </div>
            <div className="page-dot">
              <div className="ing-dot ing-page"></div>
              <div className="ing-dot ing-page"></div>
              <div className="ing-dot ing-page"></div>
            </div>
          </div>
          {/* <div className="base-sec-bottom">
            <button className="bottombtn bottombtn-w">취소</button>
            <button className="bottombtn bottombtn-b">시작</button>
          </div> */}
          <FooterButtonGroup
            prevOnClick={() => {
              setApplyStep(0);
            }}
            nextOnClick={() => {
              setApplyStep((old) => old + 1)
            }} />
        </div>
      </div>
    </div>
  );
};

export default Practice;
